module.exports = __webpack_public_path__ + "img/web_icon.bdd2b811.svg";